import React from 'react';
import { useTranslation } from 'react-i18next';

export default function StartDateTime({ start_datetime }) {
  const { t } = useTranslation();

  if (!start_datetime) {
    return <div className='rounded-full text-xs h-7 items-center leading-7'>---</div>;
  }

  const dateTime = new Date(`${start_datetime}Z`);

  if (Number.isNaN(dateTime.getTime())) {
    return <div className='rounded-full text-xs h-7 items-center leading-7'>---</div>;
  }

  const now = new Date();

  const dateStr = `${dateTime.getFullYear()}-${String(dateTime.getMonth() + 1).padStart(2, '0')}-${String(dateTime.getDate()).padStart(2, '0')}`;

  const isDateToday = dateStr === `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

  const formattedDateTime = isDateToday
    ? `${String(dateTime.getHours()).padStart(2, '0')}:${String(dateTime.getMinutes()).padStart(2, '0')}`
    : `${String(dateTime.getDate()).padStart(2, '0')} ${t(["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"][dateTime.getMonth()])} ${String(dateTime.getHours()).padStart(2, '0')}:${String(dateTime.getMinutes()).padStart(2, '0')}`;

  return <div className='rounded-full text-xs h-7 items-center leading-7'>{formattedDateTime}</div>;
}